import React from 'react';
import Headertop from '../components/Headertop'; 
import Navbar from '../components/Navbar';
import Slider from '../components/Slider';
import Courses from '../components/Courses';
import OurTeam from '../components/OurTeam';
import Offer from '../components/Offer';
import Testimonial from '../components/Testimonial';
import Discover from '../components/Discover';
import Footer from '../components/Footer';
// import CourseCard from '../components/CourseCard';
import CourseCard1 from '../components/NewCourses';
import CountDown from '../components/CountDown';

function Home() {
  return (
    <>
      <Headertop /> 
      <Navbar />
      <Slider />
      <Courses />
      {/* <CourseCard /> */}
      <CourseCard1 />
      <Offer />
      <CountDown />
      <OurTeam />
      <Testimonial />
      <Discover />
      <Footer />
    </>
  );
}

export default Home;
